module.exports = __webpack_public_path__ + "img/code.e3fcd3e6.png";